import { html, svg } from "lit";
import { API_URL } from "../api/client.js";

/** External-link icon (box with diagonal arrow). */
export const externalLinkIcon = svg`<svg viewBox="0 0 24 24" fill="none" class="w-3 h-3 inline-block ml-0.5 -mt-0.5">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
    d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3"/>
</svg>`;

/** Render a small { } badge linking to the raw API response for a given path. */
export function apiLink(path: string) {
  return html`<a
    href="${API_URL}${path}"
    target="_blank"
    title="View API response"
    class="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs rounded
           bg-hb-bg text-gray-500 border border-hb-border
           hover:text-gray-300 hover:border-gray-500 transition-colors no-underline"
    @click=${(e: Event) => e.stopPropagation()}
  >{ }</a>`;
}

/** Format an ISO date string as relative time (e.g. "2h ago", "3d ago"). */
export function relativeTime(iso: string | null): string {
  if (!iso) return "";
  const ms = Date.now() - new Date(iso).getTime();
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const days = Math.floor(hr / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}

/** Format an ISO date string as "Feb 10, 2026". */
export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** Format bytes as a human-readable string (e.g. "39.9 MB", "1.2 GB"). */
export function formatSize(bytes: number | null): string {
  if (bytes === null || bytes === undefined) return "—";
  if (bytes < 1_000_000) return `${(bytes / 1_000).toFixed(1)} kB`;
  if (bytes < 1_000_000_000) return `${(bytes / 1_000_000).toFixed(1)} MB`;
  return `${(bytes / 1_000_000_000).toFixed(1)} GB`;
}

/** Truncate a digest to first 12 hex chars. */
export function shortDigest(digest: string): string {
  return digest.replace("sha256:", "").slice(0, 12);
}

/** Truncate a git commit SHA to 7 chars. */
export function shortCommit(sha: string): string {
  return sha.slice(0, 7);
}

/** Build a GitLab commit URL. */
export function commitUrl(repo: string, sha: string): string {
  return `${repo}/-/commit/${sha}`;
}

/** Build a GitLab URL to a file at a specific commit. */
export function containerfileUrl(repo: string, sha: string, path: string): string {
  return `${repo}/-/blob/${sha}/${path}`;
}
